module.exports = require("vuetify/lib/components/VMenu");